import { render, staticRenderFns } from "./CommonRatingPie.vue?vue&type=template&id=722b2614"
import script from "./CommonRatingPie.vue?vue&type=script&lang=js"
export * from "./CommonRatingPie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports